import React from 'react'
import {
  CATEGORY_OPTIONS,
  FORMAT_OPTIONS,
  GENDER_OPTIONS,
  LIFECYCLE_OPTIONS,
  Opt,
  PLAYER_MATCH_OPTIONS,
  ROUND_OPTIONS,
  SourceCode,
  SURFACE_OPTIONS,
} from '../../../constants/carouselOptions'
import {
  CompetitionFilterSelect,
  LookupProps,
  PlayerFilterSelect,
  SeasonFilterSelect,
} from './carouselLookups'

export type FilterControl =
  | { kind: 'enum-multi'; options: readonly Opt[] }
  | { kind: 'enum-single'; options: readonly Opt[] }
  | { kind: 'number'; placeholder?: string; min?: number }
  | { kind: 'lookup'; Component: React.FC<LookupProps>; placeholder?: string }
  | { kind: 'start-window' }

export interface FilterDescriptor {
  key: string
  label: string
  hint?: string
  // Applies when at least one selected source is in this list.
  sources: SourceCode[]
  // Core filters render inline as soon as a relevant source is selected;
  // the rest live behind the "Add filter" menu.
  core?: boolean
  control: FilterControl
}

// Keys and their JSON shape must match ACE's MatchFilters struct
// (apps/ace/internal/service/layout_dynamic.go). Filters with no matching
// field there are silently dropped, so don't add one without the ACE side.
export const FILTER_REGISTRY: FilterDescriptor[] = [
  { key: 'lifecycleState', label: 'Match status', sources: ['matches'], core: true,
    control: { kind: 'enum-multi', options: LIFECYCLE_OPTIONS } },

  { key: 'categories', label: 'Categories', sources: ['matches'],
    control: { kind: 'enum-multi', options: CATEGORY_OPTIONS } },
  { key: 'competition_parent_ids', label: 'Tournaments', sources: ['matches'],
    control: { kind: 'lookup', Component: CompetitionFilterSelect } },
  { key: 'season_ids', label: 'Seasons', sources: ['matches'],
    control: { kind: 'lookup', Component: SeasonFilterSelect } },
  { key: 'formats', label: 'Match type', sources: ['matches'],
    control: { kind: 'enum-multi', options: FORMAT_OPTIONS } },
  { key: 'surfaces', label: 'Surfaces', sources: ['matches'],
    control: { kind: 'enum-multi', options: SURFACE_OPTIONS } },
  { key: 'rounds', label: 'Rounds', sources: ['matches'],
    control: { kind: 'enum-multi', options: ROUND_OPTIONS } },
  { key: 'gender', label: 'Gender', sources: ['matches'],
    control: { kind: 'enum-single', options: GENDER_OPTIONS } },
  { key: 'player_ids', label: 'Players', sources: ['matches'],
    control: { kind: 'lookup', Component: PlayerFilterSelect } },
  { key: 'player_match', label: 'Player match', hint: 'How multiple players combine', sources: ['matches'],
    control: { kind: 'enum-single', options: PLAYER_MATCH_OPTIONS } },
  { key: 'start_window', label: 'Start window', sources: ['matches'],
    control: { kind: 'start-window' } },
]

export const descriptorsForSources = (sources: SourceCode[]): FilterDescriptor[] =>
  FILTER_REGISTRY.filter(d => d.sources.some(s => sources.includes(s)))
